import React, { useState, useEffect, useRef } from 'react';
import { Button, Input, Table, Form,Popover, Spin, Select, Space} from 'antd';
import { SearchOutlined, RedoOutlined, DownloadOutlined } from '@ant-design/icons';
import PopupFrame from '../../component/popupFrame/popupFrame';//删除弹框
import Audit from '../../component/audit/audit';//審核彈框
import { Config } from '../../public/js/config';
import { Base } from '../../public/js/base';
import { ContextHandler } from '../../public/js/contextHandler';
import context from '../../public/js/context';
import moment from 'moment';//日期格式化导包
import trans from './translation';
import Message from '../../component/message/message';
import './academicStudentReport.css'

const { Option } = Select;

const PartnerStudentReport = (props) => {

    const messageRef = useRef();
    const [form] = Form.useForm();
    const [tabIndex, setTabIndex] = useState("1");
    const [isAudit, setIsAudit] = useState(false);
    const [tables, setTables] = useState([]);
    const [tablesCount, setTablesCount] = useState(0);
    const [current, setCurrent] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [searchModel, setSearchModel] = useState({});
    const [oldSearchModel, setOldSearchModel] = useState({});
    const [auditModel, setAuditModel] = useState({});
    const [isLoad, setIsLoad] = useState(false);
    const [spinInfo, setSpinInfo] = useState("");
    const [isLeave, setIsLeave] = useState(false);
    const [downloadModel, setDownloadModel] = useState("");
    const [deptModel, setDeptModel] = useState([]);

    const tableColumns = {
        studentAcctId: "studentAcctId",
        studentName: "studentName",
        birthMonth: "birthMonth",
        dataPrivacyNoticeInd: "dataPrivacyNoticeInd",
        activeInd: "activeInd",
        inactive_date: "inactive_date",
        cohortYear: "cohortYear",
        studentDept: "studentDept",
        studentProgrammeCode: "studentProgrammeCode",
        studentProgramme: "studentProgramme",
        entryYear: "entryYear",

    }

    useEffect(() => {
        searchDept();
        search(pageSize, 1, "N");
    }, []);

    useEffect(() => {
        searchDept();
        search(pageSize, 1, "N");
    }, [Config.programmeInfo.progCode]);

    const searchChange = (k, e) => {
        messageShowHandler();
        setSearchModel(newSearchModel => {
            return { ...newSearchModel, ...{ [k]: e } };
        })
    }

    //查询
    const search = (pageSizeNew, current, flag, isShowMsg) => {
        messageShowHandler();
        let model = {};
        if ("Y" === flag) {//翻頁
            model = oldSearchModel;
        } else {
            model = searchModel;
        }
        model.pageSize = pageSizeNew;
        model.startRow = (current - 1) * pageSizeNew;
        model.page = current;
        setDownloadModel(model)
        setIsLoad(true);
        setSpinInfo(trans.beQuerying[Config.backLang]);

        Base.callBackApi("student/getExportList", model).then((data) => {
            if ("SUCCESS" === data.msg) {
                if (!data.object.list && isShowMsg) {
                    errFrameShow("info", trans.noneDate[Config.backLang]);
                }
                if ("N" === flag) {
                    setOldSearchModel(JSON.parse(JSON.stringify(model)));
                }
                setTablesCount(data?.object?.total ?? 0);
                setTables(data?.object?.list ?? []);
                setCurrent(current);
                setPageSize(pageSizeNew);
            } else {
                errFrameShow("error", data.msg);
            }
        }).catch(err => { }).finally(() => setIsLoad(false));
    }

    //重置
    const reset = () => {
        messageShowHandler();
        setSearchModel({});
        setOldSearchModel({});
        setTablesCount(0);
        setTables([]);
        setPageSize(10);
    }

    const initForm = (model = {}) => {
        form.resetFields();
        form.setFieldsValue({
            studentAcctId: model.studentAcctId ?? '',
            studentName: model.studentName ?? '',
            email: model.email ?? '',
            birthMonth: (model.birthMonth && moment(model.birthMonth, Config.dateFormat6)) ?? '',
            activeInd: model.activeInd ?? '',
            inactiveDate: (model.inactiveDate && moment(model.inactiveDate)) ?? null,
            dataPrivacyNoticeInd: model.dataPrivacyNoticeInd ?? '',
        });
    }

    // 审核弹窗
    const auditCancel = () => {
        setIsAudit(false);
    }

    //取消 
    const cancel = () => {
        messageShowHandler();
        setTabIndex("1");
        search(pageSize, current, "Y");
    }

    const leaveFrameClose = (state) => {
        if (state) {
            cancel();
        }
        setIsLeave(false);
    }

    //分页 页码切换变化查询
    const onChange = (currentNew, pageSizeNew) => {
        search(pageSizeNew, currentNew, "Y");
    }

    //分页 每页條數变化查询
    const onShowSizeChange = (currentNew, pageSizeNew) => {
        search(pageSizeNew, 1, "Y");
    }

    /** 生成提示信息 */
    const errFrameShow = (style, msg) => {
        messageRef.current.setStyle(style)
        messageRef.current.setContent(msg)
        messageRef.current.setIsShow(true)
        document.documentElement.scrollTop = 0;
    }

    /** 清空提示信息 */
    const messageShowHandler = () => {
        messageRef.current.setIsShow(false)
    }

    const handleTableChange = (pagination, filters, sorter) => {
        let orderBy = "";
        if (sorter.field) {
            if (sorter.order === "ascend") {
                orderBy = tableColumns[sorter.field];
            } else if (sorter.order === "descend") {
                orderBy = tableColumns[sorter.field] + " DESC";
            }
        }
        if (!!sorter.field || !!searchModel.orderBy) {
            if (orderBy !== searchModel.orderBy) {
                searchModel.orderBy = orderBy;
                search(pageSize, 1, "N", true);
            }
        }
    }

    const downloadExcel = () => {
        messageShowHandler();//清空提示信息
        setIsLoad(true);
        setSpinInfo(trans.download[Config.backLang])
        const filename = "StudentReport" + moment(new Date()).format(Config.dateFormat3) + Base.generateFourDigitRandomNumber() + ".xlsx"
        fetch(Config.apiDownloadServer + "student/exportReport", {
            method: 'POST',
            body: JSON.stringify(downloadModel),
            headers: Config.header,
            mode: 'cors',
            cache: 'default'
        }).then(res => res.blob()).then(blob => {
            if (blob.type == "application/json") {
                var reader = new FileReader();
                reader.onload = e => {
                    var data = JSON.parse(e.target.result);
                    errFrameShow("error", data.msg);
                }
                reader.readAsText(blob);
            } else {
                if (window.navigator && window.navigator.msSaveOrOpenBlob) {// for IE
                    window.navigator.msSaveOrOpenBlob(blob, filename);
                } else {// for Non-IE (chrome, firefox etc.)
                    var a = document.createElement('a');
                    document.body.appendChild(a);
                    a.style = 'display: none';
                    var url = window.URL.createObjectURL(blob);
                    a.href = url;
                    a.download = filename
                    a.click();
                    a.remove();
                    window.URL.revokeObjectURL(url);
                }
            }
        }).catch(err => ({ err })).finally(() => {
            setIsLoad(false)
        });
    }

      const searchDept  = ()  =>{ 
        Base.callBackApi('commonDropDown/searchAllDept').then((data) => {
            if ("SUCCESS" == data.msg) {
                setDeptModel(data?.object?? []);
            } else {
                errFrameShow("error", data.msg);
            }
        }).catch(err => { }).finally(() => {
            setIsLoad(false)
        });
    }


    /*eslint-disable*/
    const columns = [
        {
            title: 'Account User ID',
            dataIndex: 'studentAcctId',
            className: 'tableWidth8',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'studentAcctId') },
        },
        {
            title: trans.studentAcctId[Config.backLang],
            dataIndex: 'studentAcctId',
            className: 'tableWidth6',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'studentAcctId') },
        },
        {
            title: trans.studentName[Config.backLang],
            dataIndex: 'studentName',
            className: 'tableWidth8',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'studentName') },
            render: (text,value) => 
                <div className = "studentDept">{value.firstName+" " + value.lastName}</div>
        },
        {
            title: "Admission Year",
            dataIndex: 'studentEntryYear',
            className: 'tableWidth8',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'studentEntryYear') },
        },
        {
            title: "Study Year Entry",
            dataIndex: 'studyYearEntry',
            className: 'tableWidth8',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'studyYearEntry') },
        },
        {
            title: trans.activeInd[Config.backLang],
            dataIndex: 'activeInd',
            className: 'tableWidth5',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'activeInd') },
            render: (text) => ContextHandler.getMapValueTransalation('activeTransalation', text)
        },
        {
            title: trans.inactiveDate[Config.backLang],
            dataIndex: 'inactiveDate',
            className: 'tableWidth7',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'inactiveDate') },
            render: text => text ? moment(text).format(Config.dateFormat5) : '',
        },
        // {
        //     title: "Programme Code",
        //     dataIndex: 'studentProgrammeCode',
        //     className: 'tableWidth9 ',
        //     sorter: (a, b) => { return Base.sortMethod(a, b, 'studentProgrammeCode') },
        // },
        {
            title: "Programme Name",
            dataIndex: 'studentProgramme',
            className: 'tableWidth9',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'studentProgramme') },
            render: (text,value) => <Popover content={text } title="" trigger="hover">
            <div className = "studentDept">{text}</div>
        </Popover>
        },
        {
            title: "Department",
            dataIndex: 'studentDept',
            className: 'tableWidth7',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'studentDept') },
            render: (text,value) => <Popover content={text && value.deptCode +"-" +text} title="" trigger="hover">
                <div className = "studentDept">{text && value.deptCode +"-" +text}</div>
            </Popover>
        },
        {
            title: trans.email[Config.backLang],
            dataIndex: 'email',
            className: 'tableWidth5',
        },        
        {
            title: 'Contact Phone',
            dataIndex: 'contactPhone',
            className: 'tableWidth7',
        },        
        {
            title: 'WeChat',
            dataIndex: 'weChat',
            className: 'tableWidth4',
        },        
        {
            title: 'Personal Web',
            dataIndex: 'personalWeb',
            className: 'tableWidth7',
        },        
        {
            title: 'WhatsApp',
            dataIndex: 'whatsApp',
            className: 'tableWidth5',
        },        
        {
            title: 'LinkedIn',
            dataIndex: 'linkedIn',
            className: 'tableWidth5',
        },        
    ];

    const submit = () => {
        search(pageSize, 1, "N", true);
    }
    

    /*eslint-enable*/

    return (
        <div id="container" className="websiteTemplate academicStudentReport">
            {/* 提示信息弹框 */}
            <div className='title'>
                <div>Student Report</div>
            </div>
            <Message ref={messageRef} />
            <div className='templateMain'>
                <Spin spinning={isLoad} size="large" tip={spinInfo}>
                    {/* 删除弹框 */}
                    {isLeave ? <PopupFrame close={leaveFrameClose} type='leave' /> : null}
                    {/* 审核彈框 */}
                    <Audit visible={isAudit} auditModel={auditModel} close={auditCancel} />
                    <Form form={form} onFinish={submit}>
                        <div className='sysSearchRow sysSearchBox'>
                            <div className='sysRow'>
                                <div className='sysCol'>
                                    <div className="sysParam messageTemplateTitle">{trans.studentAcctId[Config.backLang]}</div>
                                    <div className="sysInput">
                                        <Input type="text" value={searchModel.studentAcctId || ''} maxLength={60}
                                            placeholder={trans.studentAcctId[Config.backLang]}
                                            onKeyDown={(e) => e.key === "Enter" ? search(pageSize, 1, "N", true) : null}
                                            onChange={(e) => searchChange('studentAcctId', e.target.value)}
                                        />
                                    </div>
                                </div>
                                <div className='sysCol'>
                                    <div className="sysParam messageTemplateTitle">{trans.studentName[Config.backLang]}</div>
                                    <div className="sysInput">
                                        <Input type="text" value={searchModel.studentName || ''} maxLength={60}
                                            placeholder="Student Name"
                                            onKeyDown={(e) => e.key === "Enter" ? search(pageSize, 1, "N", true) : null}
                                            onChange={(e) => searchChange('studentName', e.target.value)}
                                        />
                                    </div>
                                </div>
                                <div className='sysCol'>
                                    <div className="sysTitle messageTemplateTitle">Admission Year</div>
                                    <div className="sysInput ">
                                    <Input type="text" value={searchModel.studentEntryYear || ''}
                                                    placeholder="Admission Year"
                                                    onKeyDown={(e) => e.key === "Enter" ? search(pageSize, 1, "N", true) : null}
                                                    onChange={(e) => searchChange('studentEntryYear', e.target.value)} />
                                    </div>
                                </div>
                                
                                <div className='sysCol'>
                                    <div className="sysTitle messageTemplateTitle">Department</div>
                                    <div className="sysInput">
                                        <Select className='sysSelect' placeholder="Department" value={searchModel.studentDept }
                                            onChange={(e) => searchChange('studentDept', e)}
                                            onKeyDown={(e) => e.key === "Enter" ? search(pageSize, 1, "N", true) : null}
                                        >

                                            <Option value=''></Option>
                                            {deptModel.map((item) => <Option key={item.deptCode} value={item.deptCode}>{item.deptCode + "-" + item.deptDisplayName}</Option>)}
                                        </Select>

                                    </div>
                                </div>
                                <div className='sysCol'>
                                    <div className="sysTitle messageTemplateTitle">{trans.activeInd[Config.backLang]}</div>
                                    <div className="sysInput">
                                        <Select placeholder={trans.activeInd[Config.backLang]} className="sysSelect" 
                                            value={searchModel.activeInd} 
                                            onChange={(e) => searchChange('activeInd', e)}
                                        >
                                            <Option value=""></Option>
                                            {context.activeTransalation.map((item) => <Option key={item.value} value={item.value}>{item[Config.backLang]}</Option>)}
                                        </Select>
                                    </div>
                                </div>
                                <div className='sysCols'>
                                    <div className="sysTitles messageTemplateTitle">Study Year Entry</div>
                                    <div className="sysInput">
                                    <Input type="text" value={searchModel.studyYearEntry || ''}
                                                    placeholder="Study Year Entry"
                                                    onKeyDown={(e) => e.key === "Enter" ? search(pageSize, 1, "N", true) : null}
                                                    onChange={(e) => searchChange('studyYearEntry', e.target.value)} />
                                    </div>
                                </div>
                                
                                <div className='sysSearchButton'>
                                    <Button className="sysBtn btnBlue" type="primary" htmlType="submit"  icon={<SearchOutlined />}>{trans.search[Config.backLang]}</Button>
                                    <Button className="sysBtn" onClick={reset} icon={<RedoOutlined />}>{trans.reset[Config.backLang]}</Button>
                                </div>
                            </div>
                        </div>
                    </Form>
                    <div className="sysLineEight"></div>
                    <Space size={[5, 5]} wrap className="sysButtonRelative">
                    {tables.length == 0 ? null :
                        <>
                            <Button className="sysBtn btnBlue" type="primary" onClick={downloadExcel}  icon={<DownloadOutlined />}>Export</Button>
                        </>
                    }
                    </Space>
                    <div className="sysTable" id="tableOne">
                        <Table
                            scroll={{ x: 2000 }}
                            rowKey="index"
                            columns={columns} //列名
                            dataSource={tables} //数据
                            pagination={{  //分页
                                showSizeChanger: true,                          //是否显示可以设置几条一页的选项
                                onChange: onChange,            //上页下页或者跳页方法
                                onShowSizeChange: onShowSizeChange,    //每页显示多少条数据方法
                                total: tablesCount,             //总共多少条数据
                                current: current,         //当前页
                                pageSize: pageSize,       //每页显示多少条数据
                                defaultCurrent: 1,                               //默认当前页为1
                                size: "small"
                            }}
                            onChange={handleTableChange}
                        />
                    </div>

                </Spin>
            </div>

        </div>
    )
}

export default PartnerStudentReport;